import * as actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  sidebar: false,
  messageBar: false,
  messageText: '',
  messageType: 'success',
  links: [
    {
      title: 'Отгрузка',
      icon: 'mdi-package-variant-closed',
      to: 'shipment'
    },
    {
      title: 'Минск',
      icon: 'mdi-home',
      // icon: 'mdi-city-variant',
      to: 'minsk'
    },
    {
      title: 'Регионы',
      icon: 'mdi-home-group',
      // icon: 'mdi-home-modern',
      to: 'regions'
    }
  ]
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
